module.exports = __webpack_public_path__ + "img/haibao3@2x_new.eb67706c.png";